import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const MOBILE_BREAKPOINT = 768;
function useIsMobile() {
    const [isMobile, setIsMobile] = __WEBPACK_EXTERNAL_MODULE_react__.useState();
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const mql = globalThis.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const onChange = ()=>{
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };
        mql.addEventListener('change', onChange);
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        return ()=>{
            mql.removeEventListener('change', onChange);
        };
    }, []);
    return Boolean(isMobile);
}
export { useIsMobile };

//# sourceMappingURL=use-mobile.js.map